import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../abstracts/abstract-control-value-accessor.component';
import { FormUtil, ObjectUtil } from '../../utils';
import { IConfig } from 'ngx-mask';
import { InputMaskConfig } from '../../models/input-mask-config';

@Component({
    selector: 'px-input',
    templateUrl: './input.component.html',
})
export class InputComponent extends AbstractControlValueAccessorComponent implements ControlValueAccessor {
    @Input() inputType = 'text';
    @Input() maxLength: string;
    @Input() symbol: string;

    @Input() set type(mask: 'currency' | 'percent' | 'int' | 'decimal' | InputMaskConfig) {
        this.toggleType(mask);
    }

    public maskObject: { mask?: string } & Partial<IConfig> = {};

    constructor(@Optional() @Self() public ngControl: NgControl) {
        super();
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }

    private toggleType(val: any) {
        if (ObjectUtil.isEmpty(val)) {
            return;
        }

        if (typeof val === 'string') {
            switch (val) {
                case 'currency':
                    this.maskObject = {
                        mask: '0*,00',
                        dropSpecialCharacters: false,
                    };
                    this.symbol = '€';
                    break;
                case 'percent':
                    this.maskObject = {
                        mask: 'percent',
                    };
                    break;
                case 'int':
                    this.maskObject = {
                        mask: `0*`,
                    };
                    break;
                case 'decimal':
                    this.maskObject = {
                        mask: `0*,00`,
                        dropSpecialCharacters: false,
                    };
                    break;
            }
        } else {
            this.maskObject = { ...this.maskObject, ...val };
        }
    }

    get formControl() {
        return this.ngControl ? this.ngControl.control : null;
    }

    get isRequired() {
        return this.formControl && FormUtil.hasValidatorKey(this.formControl, 'required');
    }

    get hasError() {
        return this.formControl && this.formControl.errors;
    }

    get hasErrorAndIsTouched() {
        return this.hasError && this.formControl.touched;
    }

    get errorMessage() {
        return FormUtil.getFirstError(this.formControl).replace('#LABEL', this.label ? this.label : 'Dieses Feld');
    }
}
